/**
 * OrganicLayer — wrapper que adiciona handheld shake orgânico via @remotion/noise
 *
 * Elimina o look "AI robô" das compositions ao adicionar micro-movimento
 * determinístico (seed-based, não Math.random) em X, Y e rotação.
 *
 * Uso:
 * <OrganicLayer intensity="subtle">
 *   {children}
 * </OrganicLayer>
 */
import React from "react";
import {AbsoluteFill, useCurrentFrame} from "remotion";
import {noise2D} from "@remotion/noise";

export interface OrganicLayerProps {
  children: React.ReactNode;
  /** Intensidade do shake — "subtle" para talking heads, "medium" para drama */
  intensity?: "off" | "subtle" | "medium" | "strong";
  /** Seed único por composition para não sincronizar shakes */
  seed?: string;
  /** Escala temporal — menor = mais lento e suave (default: 30) */
  timeScale?: number;
}

const INTENSITIES = {
  off:    {xy: 0,   rot: 0},
  subtle: {xy: 2.5, rot: 0.08},
  medium: {xy: 5,   rot: 0.15},
  strong: {xy: 10,  rot: 0.3},
} as const;

export const OrganicLayer: React.FC<OrganicLayerProps> = ({
  children,
  intensity = "subtle",
  seed = "organic",
  timeScale = 30,
}) => {
  const frame = useCurrentFrame();

  if (intensity === "off") {
    return <AbsoluteFill>{children}</AbsoluteFill>;
  }

  const {xy, rot} = INTENSITIES[intensity];
  const t = frame / timeScale;

  const dx  = noise2D(`${seed}-x`,  t, 0) * xy;
  const dy  = noise2D(`${seed}-y`,  t, 0.5) * xy;
  const deg = noise2D(`${seed}-rot`, t, 1) * rot;

  return (
    <AbsoluteFill
      style={{
        transform: `translate(${dx}px, ${dy}px) rotate(${deg}deg)`,
        // Escalar ligeiramente para esconder bordas do shake
        scale: "1.02",
      }}
    >
      {children}
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
